import { forwardRef } from 'react';
import { useField, useForwardingRef } from '@arc/frontend/util-common';
import { FormControl } from '../FormControl';
import { Textarea } from './Textarea';
export const TextareaWithControl = forwardRef(function TextareaWithControl({
  name,
  defaultValue,
  context,
  forcedErrorMessage,
  label,
  labelStyle,
  outerStyle,
  helperStyle,
  ...other
}, forwardedRef) {
  const {
    field: {
      ref: fieldRef,
      ...restField
    },
    fieldState: {
      invalid
    },
    errorMessage
  } = useField({
    name,
    defaultValue,
    ...context
  });
  const ref = useForwardingRef(null, [forwardedRef, fieldRef]);
  return <FormControl label={label} labelStyle={labelStyle} helperText={forcedErrorMessage ?? errorMessage} helperStyle={helperStyle} error={forcedErrorMessage ? true : invalid} outerStyle={outerStyle}>
			<Textarea ref={ref} error={forcedErrorMessage ? true : invalid} {...other} {...restField} />
		</FormControl>;
});